import { styled, css } from "@pigment-css/react";
import { clsx } from "clsx";
import { ChevronDown } from "@acto/web-common/components";

interface SectionDividerProps {
  onClick?: () => void;
  isExpanded?: boolean;
}

const Container = styled("div")({
  display: "flex",
  alignItems: "center",
  width: "100%",
  gap: "4px",
});

const clickableStyles = css({
  cursor: "pointer",
});

const Line = styled("div")(({ theme }) => ({
  flex: 1,
  height: "1px",
  backgroundColor: theme.managementView.colors.neutral[8],
}));

const IconContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "48px",
  height: "36px",
  border: `1px solid ${theme.managementView.colors.neutral[8]}`,
  borderRadius: "50px",
  flexShrink: 0,

  "& svg": {
    width: "14px",
    height: "14px",
    color: theme.managementView.colors.neutral[90],
    transition: "transform 0.3s ease",
  },
}));

const interactiveIconStyles = css(({ theme }) => ({
  cursor: "pointer",
  "&:hover": {
    borderColor: theme.managementView.colors.neutral[24],
  },
}));

const expandedIconStyles = css({
  "& svg": {
    transform: "rotate(180deg)",
  },
});

export const SectionDivider = ({ onClick, isExpanded }: SectionDividerProps) => {
  return (
    <Container onClick={onClick} className={clsx(onClick && clickableStyles)}>
      <Line />
      <IconContainer className={clsx(onClick && interactiveIconStyles, isExpanded && expandedIconStyles)}>
        <ChevronDown />
      </IconContainer>
      <Line />
    </Container>
  );
};
